import { makeTAddIsNotMoralOrIgnored } from '../../TYPE/logic';
export var showLogic = makeTAddIsNotMoralOrIgnored({});
export var makeShowLogic = function (parentNameAdditionalPaths) { return makeTAddIsNotMoralOrIgnored({
    parentNameAdditionalPaths: parentNameAdditionalPaths,
}); };
